// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SpecimenRouteImport } from './routes/specimen'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as McpConsentRouteImport } from './routes/mcp-consent'
import { Route as LoginRouteImport } from './routes/login'
import { Route as InstallRouteImport } from './routes/install'
import { Route as ConnectorsRouteImport } from './routes/connectors'
import { Route as AppRouteImport } from './routes/app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SettingsIndexRouteImport } from './routes/settings.index'
import { Route as SettingsSectionRouteImport } from './routes/settings.$section'
import { Route as AuthGoogleCallbackRouteImport } from './routes/auth/google/callback'

const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const SpecimenRoute = SpecimenRouteImport.update({
            id: '/specimen',path: '/specimen',getParentRoute: () => rootRouteImport
          })
const SettingsRoute = SettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const McpConsentRoute = McpConsentRouteImport.update({
            id: '/mcp-consent',path: '/mcp-consent',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const InstallRoute = InstallRouteImport.update({
            id: '/install',path: '/install',getParentRoute: () => rootRouteImport
          })
const ConnectorsRoute = ConnectorsRouteImport.update({
            id: '/connectors',path: '/connectors',getParentRoute: () => rootRouteImport
          })
const AppRoute = AppRouteImport.update({
            id: '/app',path: '/app',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const SettingsIndexRoute = SettingsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => SettingsRoute
          })
const SettingsSectionRoute = SettingsSectionRouteImport.update({
            id: '/$section',path: '/$section',getParentRoute: () => SettingsRoute
          })
const AuthGoogleCallbackRoute = AuthGoogleCallbackRouteImport.update({
            id: '/auth/google/callback',path: '/auth/google/callback',getParentRoute: () => rootRouteImport
          })





const SettingsRouteChildren = {
  SettingsSectionRoute: SettingsSectionRoute,SettingsIndexRoute: SettingsIndexRoute
}

const SettingsRouteWithChildren = SettingsRoute._addFileChildren(SettingsRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AppRoute: AppRoute,ConnectorsRoute: ConnectorsRoute,InstallRoute: InstallRoute,LoginRoute: LoginRoute,McpConsentRoute: McpConsentRoute,PricingRoute: PricingRoute,PrivacyRoute: PrivacyRoute,SettingsRoute: SettingsRouteWithChildren,SpecimenRoute: SpecimenRoute,TermsRoute: TermsRoute,AuthGoogleCallbackRoute: AuthGoogleCallbackRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)